import styled from "@emotion/styled";
import Visualization from "metabase/visualizations/components/Visualization";

export const FullVisualization = styled(Visualization)`
  display: flex;
  flex: 1 0 0;
`;
